export const FETCH_CAMPAIGNS = 'FETCH_CAMPAIGNS';
export const UPDATE_CAMPAIGNS = 'UPDATE_CAMPAIGNS';
export const CLIENTS_BY_PARTNER = 'CLIENTS_BY_PARTNER';
export const CLIENTS_CAMPAIGN_BY_ID = 'CLIENTS_CAMPAIGN_BY_ID';
export const UPDATE_CAMPAIGN_SELECT = 'UPDATE_CAMPAIGN_SELECT';
export const UPDATE_CAMPAIGN_SELECT_DEFAULT = 'UPDATE_CAMPAIGN_SELECT_DEFAULT';
export const UPDATE_CLIENTS_BY_PARTNER = 'UPDATE_CLIENTS_BY_PARTNER';
export const CREATE_CLIENTS_CAMPAIGN = 'CREATE_CLIENTS_CAMPAIGN';
export const UPDATE_CLIENTS_CAMPAIGN_BY_ID = 'UPDATE_CLIENTS_CAMPAIGN_BY_ID';
export const SET_CAMPAIGN_PROPERTY = 'SET_CAMPAIGN_PROPERTY';
export const SET_CAMPAIGN = 'SET_CAMPAIGN';
export const CAMPAIGN_FRONT_DETAIL_BY_ID = 'CAMPAIGN_FRONT_DETAIL_BY_ID';
export const UPDATE_CAMPAIGN_FRONT_DETAIL = 'UPDATE_CAMPAIGN_FRONT_DETAIL';
export const CAMPAIGN_DELETE_BY_ID = 'CAMPAIGN_DELETE_BY_ID';
export const UPDATE_CAMPAIGN_CLONE_DATA = 'UPDATE_CAMPAIGN_CLONE_DATA';
export const CREATE_NEW_CAMPAIGN = 'CREATE_NEW_CAMPAIGN';
export const UPDATE_CAMPAIGN_BY_ID = 'UPDATE_CAMPAIGN_BY_ID';
export const UPDATE_CLIENTS_DEFAULT_EDIT_CAMPAIGN = 'UPDATE_CLIENTS_DEFAULT_EDIT_CAMPAIGN';
export const UPDATE_CLIENTS_ASSOCIATED_EDIT_CAMPAIGN = 'UPDATE_CLIENTS_ASSOCIATED_EDIT_CAMPAIGN';
export const COPY_CAMPAIGN_SELECTED_DATA = 'COPY_CAMPAIGN_SELECTED_DATA';
export const UPDATE_LIST_FUTURE_CUSTOMER_ASSOCIATED = 'UPDATE_LIST_FUTURE_CUSTOMER_ASSOCIATED';
export const CLONE_CAMPAIGN = 'CLONE_CAMPAIGN';
export const EDIT_CAMPAIGN = 'EDIT_CAMPAIGN';
export const GOTO_POPUPSTORE = 'GOTO_POPUPSTORE';
export const UNSUBSCRIBE_CAMPAIGN = 'UNSUBSCRIBE_CAMPAIGN';
export const UNPUBLISH_CAMPAIGN = 'UNPUBLISH_CAMPAIGN';
export const MARKETPLACE = 'MARKETPLACE';
export const GOTO_MARKETPLACE = 'GOTO_MARKETPLACE';
export const CAMPAIGN_FRONT_DETAIL_RESET = 'CAMPAIGN_FRONT_DETAIL_RESET';
export const CAMPAIGN_BY_ID = 'CAMPAIGN_BY_ID';
export const FETCH_SECTION_ODATA = 'FETCH_SECTION_ODATA';
export const UPDATE_SECTION_ODATA = 'UPDATE_SECTION_ODATA';
export const RESET_SECTION_ODATA = 'RESET_SECTION_ODATA';
export const FETCH_CAR_FEATURES = 'FETCH_CAR_FEATURES';
export const UPDATE_CAR_FEATURES = 'UPDATE_CAR_FEATURES';
export const RESET_EDIT_CAMPAIGN_FIELDS_CHANGED = 'RESET_EDIT_CAMPAIGN_FIELDS_CHANGED';
export const PUBLISH_OMEGA = 'PUBLISH_OMEGA';
export const GET_NEW_CAMPAIGN_DATA = 'GET_NEW_CAMPAIGN_DATA';
export const GOTO_STRATOS_B2C = 'GOTO_STRATOS_B2C';
export const VEHICLES_LIBERATION = 'VEHICLES_LIBERATION';
export const STOCK_UPDATE = 'STOCK_UPDATE';
export const UPDATE_STOCK_RESERVED = 'UPDATE_STOCK_RESERVED';
export const UPDATE_MULTIPLE_CAMPAIGNS_EDIT = 'UPDATE_MULTIPLE_CAMPAIGNS_EDIT';
export const UPDATE_MASTER_DATA_CAMPAIGN = 'UPDATE_MASTER_DATA_CAMPAIGN';
export const CAMPAIGNS_CLEAN_OFFER_FAMILY = 'CAMPAIGNS_CLEAN_OFFER_FAMILY';
export const UPDATE_ODATA_BY_DRAG_AND_DROP = 'UPDATE_ODATA_BY_DRAG_AND_DROP';
export const SAVE_TO_SORT_CAMPAIGN = 'SAVE_TO_SORT_CAMPAIGN';
export const SET_CAMPAIGNS_USE_TO_SORT = 'SET_CAMPAIGNS_USE_TO_SORT';
export const GET_TEMPLATES_BY_CAMPAIGN = 'GET_TEMPLATES_BY_CAMPAIGN';
export const CAMPAIGN_GALLERY_BY_ID = 'CAMPAIGN_GALLERY_BY_ID';
